(function () {
  'use strict';

  if (window.RoxieCollectionStoryReady) {
    return;
  }

  window.RoxieCollectionStoryReady = true;


  document.addEventListener(
    'click',
    function (event) {

      const close =
        event.target.closest(
          '[data-rx-story-close]'
        );

      if (!close) {
        return;
      }


      const story =
        close.closest(
          '[data-rx-story]'
        );


      const details =
        close.closest(
          '[data-rx-story-details]'
        );


      if (
        !story ||
        !details
      ) {
        return;
      }


      details.open = false;


      const offset =
        window.innerWidth < 750
          ? 78
          : 105;


      const top =
        story.getBoundingClientRect().top
        +
        window.scrollY
        -
        offset;


      window.scrollTo({
        top:Math.max(0,top),
        behavior:'smooth'
      });

    }
  );

})();